import { useDispatch, useSelector } from "react-redux";
import { addTopRatedMovies } from "../store/slices/moviesSlice";
import { useEffect, useCallback } from "react";
import { API_OPTIONS } from "../utils/constants";
import { RootState } from "../store";

const useTopRatedMovies = () => {
  const dispatch = useDispatch();
  const topRatedMovies = useSelector((store: RootState) => store.movies.topRatedMovies);

  const getTopRatedMovies = useCallback(async () => {
    try {
      const data = await fetch(
        "https://api.themoviedb.org/3/movie/top_rated?page=1",
        API_OPTIONS
      );
      const json = await data.json();
      dispatch(addTopRatedMovies(json.results));
    } catch (error) {
      console.error("Error fetching top rated movies:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!topRatedMovies) getTopRatedMovies();
  }, [topRatedMovies, getTopRatedMovies]);
};

export default useTopRatedMovies;
